import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Detroit Anti-War Committee";

const TITLES: Record<string, string> = {
  "/": SITE,
  "/about": `About — ${SITE}`,
  "/detroit-divest": `Detroit Divest — ${SITE}`,
  "/zines": `Zines — ${SITE}`,
  "/join-us": `Join us — ${SITE}`,
};

/**
 * Keeps <title> in step with the route (WCAG 2.4.2 Page Titled).
 *
 * A single-page app never reloads, so the title set in index.html would
 * otherwise describe every page as the home page — leaving screen reader users
 * and anyone scanning tabs or history with five identical entries.
 */
function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = TITLES[pathname] ?? SITE;
  }, [pathname]);

  return null;
}

export default DocumentTitle;
